export function root(bid: string): string {
	return `/brands/${bid}/brandguide/v2`
}

export function upload(bid: string): string {
	return `${root(bid)}/upload`
}

export function documents(bid: string): string {
	return `${root(bid)}/documents`
}

export function review(bid: string, documentId: string): string {
	return `${root(bid)}/documents/${documentId}`
}

export function allAssets(bid: string): string {
	return `${root(bid)}/assets`
}

export function settings(bid: string): string {
	return `${root(bid)}/settings`
}
